{
  "pages": {
    "organizationsTitle": "Tổ chức",
    "appBarTitle": "Quản lý tổ chức",
    "provisionTitle": "Tạo tổ chức mới",
    "permissionDenied": "Bạn không có quyền quản trị nền tảng."
  },
  "steps": {
    "organization": "Tổ chức",
    "clinicAdmin": "Quản trị phòng khám",
    "headClinic": "Chi nhánh chính"
  },
  "orgTypes": {
    "dental_clinic": "Phòng khám nha khoa",
    "dental_hospital": "Bệnh viện răng hàm mặt",
    "dental_chain": "Hệ thống nha khoa",
    "individual_practitioner": "Bác sĩ cá nhân",
    "hospital": "Bệnh viện",
    "chain": "Chuỗi phòng khám",
    "other": "Khác"
  },
  "fields": {
    "name": "Tên tổ chức",
    "slug": "Slug",
    "orgType": "Loại tổ chức",
    "adminEmail": "Email quản trị",
    "adminFirstName": "Tên quản trị",
    "adminLastName": "Họ quản trị",
    "adminPassword": "Mật khẩu",
    "clinicName": "Tên chi nhánh chính",
    "clinicAddress": "Địa chỉ",
    "clinicPhone": "Điện thoại",
    "clinicEmail": "Email chi nhánh",
    "orgEmail": "Email tổ chức",
    "orgPhone": "Điện thoại tổ chức",
    "street": "Địa chỉ (Số nhà, Tên đường)",
    "ward": "Phường/Xã",
    "province": "Tỉnh/Thành phố",
    "taxCode": "Mã số thuế",
    "taxCodeOptional": "Mã số thuế (tùy chọn)",
    "adminUsername": "Tên đăng nhập",
    "adminGender": "Giới tính",
    "adminPhone": "Điện thoại quản trị",
    "status": "Trạng thái",
    "createdAt": "Ngày tạo",
    "plan": "Gói",
    "maxUsers": "Tối đa user",
    "maxClinics": "Tối đa chi nhánh"
  },
  "placeholders": {
    "name": "Nhập tên tổ chức",
    "slug": "Ví dụ: nha-khoa-abc",
    "orgEmail": "Nhập email tổ chức",
    "orgPhone": "Ví dụ: 0901234567",
    "street": "Số nhà, tên đường",
    "province": "Chọn tỉnh/thành phố",
    "ward": "Chọn phường/xã",
    "taxCode": "Nhập mã số thuế",
    "adminFirstName": "Nhập tên",
    "adminLastName": "Nhập họ và chữ lót",
    "adminUsername": "Nhập tên đăng nhập",
    "adminPassword": "Nhập mật khẩu",
    "adminEmail": "Nhập email quản trị",
    "adminPhone": "Ví dụ: 0901234567",
    "selectGender": "Chọn giới tính",
    "clinicName": "Nhập tên chi nhánh chính",
    "clinicEmail": "Nhập email chi nhánh",
    "clinicPhone": "Ví dụ: 0901234567",
    "quota": "Để trống nếu dùng hạn mức gói"
  },
  "status": {
    "active": "Hoạt động",
    "inactive": "Ngừng",
    "suspended": "Tạm khóa"
  },
  "actions": {
    "provision": "Cấp phát",
    "next": "Tiếp",
    "back": "Quay lại",
    "refresh": "Làm mới",
    "view": "Xem",
    "provisionNewClinic": "Tạo tổ chức",
    "provisionFirstClinic": "Cấp phát tổ chức đầu tiên",
    "provisionClinic": "Cấp phát tổ chức",
    "provisioning": "Đang cấp phát...",
    "provisionAnother": "Cấp phát tổ chức khác",
    "backToOrganizations": "Quay lại danh sách tổ chức",
    "editPlan": "Gói",
    "savePlan": "Lưu gói",
    "savingPlan": "Đang lưu gói"
  },
  "table": {
    "name": "Tên",
    "slug": "Slug",
    "type": "Loại",
    "status": "Trạng thái",
    "createdAt": "Ngày tạo",
    "contact": "Liên hệ",
    "actions": "Thao tác"
  },
  "empty": "Chưa có tổ chức",
  "validation": {
    "nameRequired": "Vui lòng nhập tên tổ chức",
    "slugRequired": "Vui lòng nhập slug",
    "adminEmailRequired": "Vui lòng nhập email quản trị",
    "adminPasswordRequired": "Vui lòng nhập mật khẩu",
    "clinicNameRequired": "Vui lòng nhập tên chi nhánh",
    "requiredFields": "Vui lòng nhập đầy đủ các trường bắt buộc",
    "quota": "Hạn mức phải là số nguyên từ 1 trở lên, hoặc để trống"
  },
  "toasts": {
    "loadFailed": "Không tải được danh sách tổ chức",
    "provisionSuccess": "Đã cấp phát tổ chức thành công",
    "provisionFailed": "Cấp phát tổ chức thất bại",
    "provisionTimeout": "Chưa nhận được kết quả. Tổ chức có thể đã được tạo — kiểm tra danh sách trước khi tạo lại.",
    "planSaved": "Đã cập nhật gói",
    "planSaveFailed": "Không cập nhật được gói"
  },
  "plans": {
    "free": "Free",
    "basic": "Basic",
    "professional": "Professional",
    "enterprise": "Enterprise"
  },
  "features": {
    "overview": "Tổng quan",
    "patients": "Bệnh nhân",
    "appointments": "Lịch hẹn",
    "catalog": "Danh mục và điều trị",
    "payments": "Thanh toán",
    "leads": "Lead",
    "finance": "Thu chi và sổ quỹ",
    "promotions": "Khuyến mãi",
    "internal_chat": "Chat nội bộ",
    "messaging": "Hộp thư",
    "warehouse": "Kho",
    "labo": "Labo",
    "hr": "Nhân sự",
    "reports": "Báo cáo",
    "automation": "Tự động hóa"
  },
  "planDialog": {
    "title": "Gói của {{name}}",
    "catalogLimits": "Hạn mức gói: {{users}} user, {{clinics}} chi nhánh",
    "quotaHint": "Để trống để dùng hạn mức của gói. Enterprise để trống là không trần.",
    "extraFeatures": "Module thêm ngoài gói"
  },
  "success": {
    "title": "Đã cấp phát tổ chức",
    "description": "Chia sẻ thông tin đăng nhập này với quản trị viên. Họ sẽ được yêu cầu đổi mật khẩu trong lần đăng nhập đầu tiên.",
    "adminUsername": "Tên đăng nhập quản trị"
  }
}
